/**
 * Вердикт кнопки: живая или труп. Не «кэф где-то рядом».
 *
 * Полная проверка — это лента (вилка ещё есть, цена не залипла, рынок
 * подтверждает) плюс текст на обеих страницах. Зелёным подписываем только
 * когда каждая нога — `match`. Отсутствующая вкладка, серая страница и
 * уехавшее число — отказ. Ближайшее чужое число называем как факт трупа,
 * не как допуск.
 */

import type { SnapOne, SnapReply } from './snap';

export type CheckSay = { ok: boolean; text: string };

export function forkCheck(input: {
  dead: boolean;
  doubtDead: boolean;
  stuck: string | null;
  snap: SnapReply | null;
  deskOn: boolean;
  nameOf: (venue: string) => string;
}): CheckSay {
  if (input.dead) return { ok: false, text: 'вилка закончилась, ставить нельзя' };
  if (input.doubtDead) {
    return {
      ok: false,
      text: 'рынок эту вилку не подтверждает — зелёным не подпишем, сверьте кэф на сайте',
    };
  }
  if (input.stuck !== null) {
    return {
      ok: false,
      text: `цена в ${input.stuck} не двигалась — подтвердить, что вилка жива, мы не можем`,
    };
  }
  if (input.snap === null) {
    return {
      ok: false,
      text: 'страницы не видим: расширение молчит. зелёным не подпишем',
    };
  }
  const rows = input.snap.legs;
  if (rows.length === 0) {
    return { ok: false, text: 'страницы не видим. зелёным не подпишем' };
  }
  const absent = rows.filter((one) => one.state === 'absent');
  if (absent.length === rows.length && input.deskOn) {
    return {
      ok: false,
      text: 'столы в AdsPower этот браузер не читает. смотри полосы в окнах контор — отсюда не подпишем',
    };
  }
  if (rows.every((one) => one.state === 'match')) {
    return {
      ok: true,
      text: `жива: на страницах есть ${rows.map((one) => one.ours).join(' / ')}`,
    };
  }
  return { ok: false, text: `труп: ${rows.map((one) => lineOf(one, input.nameOf)).join('. ')}` };
}

function lineOf(one: SnapOne, nameOf: (venue: string) => string): string {
  const name = nameOf(one.venue);
  if (one.state === 'match') return `${name}: ${one.ours} есть`;
  if (one.state === 'moved') {
    return one.closest === null
      ? `${name}: нашего ${one.ours} нет`
      : `${name}: нашего ${one.ours} нет, на странице ${one.closest}`;
  }
  if (one.state === 'unreadable') return `${name}: страницу не прочитали`;
  return `${name}: вкладка не открыта`;
}
